import { IonCol, IonGrid, IonIcon, IonRow, IonSkeletonText, IonText } from '@ionic/react';
import { buildOutline } from 'ionicons/icons';
import { IonCardWrapper } from './JobCard.styles';

const JobCardSkeleton: React.FC = () => {
  return (
    <IonCardWrapper>
      <IonGrid>
        <IonRow>
          <IonCol size="10">
            <IonGrid>
              <IonRow>
                <IonCol size="12">
                  <div className="ion-text-nowrap flexed flexed-center">
                    <IonIcon icon={buildOutline} size="large" className="title-icon" />
                    <IonText className="flexed flexed-fill"><IonSkeletonText animated style={{ width: '100%' }} /></IonText>
                  </div>
                </IonCol>
              </IonRow>
            </IonGrid>
            <IonText><IonSkeletonText animated style={{ width: '100%' }} /></IonText>
          </IonCol>
          <IonCol size="2" className="ion-text-right flexed flexed-center ion-justify-content-end">
            <IonRow>
              <IonCol size="12" className="flexed col">
              </IonCol>
            </IonRow>
          </IonCol>
        </IonRow>
      </IonGrid>
    </IonCardWrapper>
  );
};

export default JobCardSkeleton;
